import { render } from "./VitamindPlus.vue?vue&type=template&id=427c2d14&scoped=true"
import script from "./VitamindPlus.vue?vue&type=script&lang=js"
export * from "./VitamindPlus.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-427c2d14"

export default script